import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-text">Generating your presentation...</p>
      <p className="loading-subtext">This may take up to 30 seconds</p>
    </div>
  );
};

export default LoadingSpinner;
